var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.00195C4 0.897384 3.10457 0.00195312 2 0.00195312C0.895431 0.00195312 0 0.897384 0 2.00195V12.002C0 13.1065 0.895431 14.002 2 14.002C3.10457 14.002 4 13.1065 4 12.002V2.00195ZM13 2.00195C13 0.897384 12.1046 0.00195312 11 0.00195312C9.89543 0.00195312 9 0.897384 9 2.00195V12.002C9 13.1065 9.89543 14.002 11 14.002C12.1046 14.002 13 13.1065 13 12.002V2.00195Z",
    fill: "#307FF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.584aa66fda6421962345f9fe6ca49b3f.svg";
export { ForwardRef as ReactComponent };